import moment from 'moment';

export default function syncDateWithOriginalTime(dateWithTime, newDate, format) {
	return moment(newDate, format)
		.set({
			hour: moment(dateWithTime).get('hour'),
			minute: moment(dateWithTime).get('minute'),
			second: moment(dateWithTime).get('second'),
		})
		.toDate()
}



// WEBPACK FOOTER //
// ./src/core/utils/syncDateWithOriginalTime.js